import React, {Component, Fragment} from 'react'
import GlgSelect from '../../../shared/components/glg_select'
import PropTypes from 'prop-types'
import {Row, Col} from 'react-bootstrap'
import RoundListComponent from './round_list_component'
import CheckInListComponent from './check_in_list_component'
import PlayerInfoComponent from './player_info_component'
import EventListComponent from './event_list_component'
import ViewType from './view_type'


class ParticipationHistoryComponent extends Component {
  constructor(props) {
    super(props)
    this.filterParticipationHistory = this.props.filterParticipationHistory.bind(this)
    this.fetchParticipationHistoryData = this.props.fetchParticipationHistoryData.bind(this)
    this.fetchMoneyEarnedInformation = this.props.fetchMoneyEarnedInformation.bind(this)
    // this.selectOpenedMoneyEarnedInformationPopup = this.props.selectOpenedMoneyEarnedInformationPopup.bind(this)
    this.viewChanged = this.props.viewChanged.bind(this)
    this.filterHistory = this.filterHistory.bind(this)
  }

  filterHistory(season) {
    this.filterParticipationHistory(season)
    this.fetchParticipationHistoryData()
  }

  render() {
    const upcomingRoundsTitle = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.upcoming_rounds_title')
    const upcomingEventsTitle = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.future_events_title')
    const pastRoundsTitle = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.past_rounds_title')
    const pastEventsTitle = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.past_events_title')
    const checkInTitle = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.checkin_title')
    const upcomingRoundsNoInfoMessage = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.upcoming_rounds_no_info_message')
    const upcomingEventsNoInfoMessage = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.future_no_info_message')
    const pastRoundsNoInfoMessage = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.past_rounds_no_info_message')
    const pastEventsNoInfoMessage = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.past_no_info_message')
    const checkInMessage = !window.I18n ? '' : window.I18n.t('player_activity.participation_history.checkin_message')
    const dropdownClass = this.props.seasons.length > 1 ? '' : 'hidden'

    return (
      <Row className='participation-history'>
        <PlayerInfoComponent
          name={this.props.playerName}
          usgaIndex={this.props.usgaIndex}
          photoUrl={this.props.photoUrl}
          editProfileUrl={this.props.editProfileUrl}
          target={this.props.target}
          hiText={this.props.hiText} />
        <Col xs={ 12 } sm={ 5 } className={dropdownClass}>
          <div className='panel panel-default short-panel'>
            <div className='panel-body'>
              <Col xs={ 4 } sm={ 3 }>
                <div className='panel-body-title'>
                  { !window.I18n ? '' : window.I18n.t('player_activity.participation_history.season') }
                </div>
              </Col>
              <Col xs={ 8 } sm={ 9 }>
                <GlgSelect items={ this.props.seasons } onChange={ (s) => this.filterHistory(s) } value={ this.props.seasonId } />
              </Col>
            </div>
          </div>
        </Col>
        <Col xs={ 12 } sm={ 7 } className={ 'view-type-filter' }>
          <ViewType
            viewType={ this.props.viewOption }
            onChange={ this.props.viewChanged }
            fetchData={ this.props.fetchParticipationHistoryData }
            disabled={ this.props.dataIsLoading} />
        </Col>
        { this.props.viewOption === 'round' ? (
            <Fragment>
              <RoundListComponent
                rounds={ this.props.futureRounds }
                roundsCount={ this.props.futureRoundsCount }
                past={ false }
                sectionTitle={ upcomingRoundsTitle }
                dataIsLoading={ this.props.dataIsLoading}
                noInfoMessage={ upcomingRoundsNoInfoMessage }
                page={ this.props.pageFutureRounds }
                target={ this.props.target }
                setCurrentPage={ (page) => this.props.setPage('round', 'future', page) } />
              <RoundListComponent
                rounds={ this.props.pastRounds }
                roundsCount={ this.props.pastRoundsCount }
                past={ true }
                sectionTitle={ pastRoundsTitle }
                dataIsLoading={ this.props.dataIsLoading}
                noInfoMessage={ pastRoundsNoInfoMessage }
                page={ this.props.pagePastRounds }
                target={ this.props.target }
                isOpenedLeaderboardPopup={ this.props.isOpenedLeaderboardPopup }
                currentlyRoundLeaderboardPopup={ this.props.currentlyRoundLeaderboardPopup }
                onLeaderboardOpen={ this.props.onLeaderboardOpen }
                loadingLeaderboards={ this.props.loadingLeaderboards }
                fetchLeaderboardStart={this.props.fetchLeaderboardStart}
                fetchLeaderboardEnd={this.props.fetchLeaderboardEnd}
                setCurrentPage={ (page) => this.props.setPage('round', 'past', page) } />
            </Fragment>
          ) : (
            <Fragment>
              <EventListComponent
                events={ this.props.futureEvents }
                eventsCount={ this.props.futureEventsCount }
                sectionTitle={ upcomingEventsTitle }
                dataIsLoading={ this.props.dataIsLoading}
                moneyEarnedEnabled={ false}
                noInfoMessage={ upcomingEventsNoInfoMessage }
                page={ this.props.pageFutureEvents }
                setCurrentPage={ (page) => this.props.setPage('event', 'future', page) }
                target={ this.props.target } />
              <EventListComponent
                events={ this.props.pastEvents }
                eventsCount={ this.props.pastEventsCount }
                sectionTitle={ pastEventsTitle }
                dataIsLoading={ this.props.dataIsLoading}
                moneyEarnedEnabled={ this.props.isPGA}
                totalMoneyEarned={ this.props.moneyEarnedTotal }
                noInfoMessage={ pastEventsNoInfoMessage }
                target={ this.props.target }
                areLoadingEventsIds={ this.props.areLoadingEventsIds }
                fetchMoneyEarnedInformation={ this.fetchMoneyEarnedInformation }
                loadedEvents={ this.props.loadedEvents }
                isOpenedEventPopup={ this.props.isOpenedEventPopup }
                currentlyOpenedEventPopup={ this.props.currentlyOpenedEventPopup }
                onPopupOpen={ this.props.selectOpenedMoneyEarnedInformationPopup }
                page={ this.props.pagePastEvents }
                setCurrentPage={ (page) => this.props.setPage('event', 'past', page) } />
            </Fragment>
          )}


        {this.props.showCheckInTable && (
          <CheckInListComponent
            checkins={ this.props.checkInList }
            target={ this.props.target }
            noInfoMessage={ checkInMessage }
            sectionTitle={ checkInTitle }
            dataIsLoading={ this.props.dataIsLoading }
            checkInsCount={ this.props.checkInsCount }
            deleteCheckIn={ this.props.deleteCheckIn } />
        )}
      </Row>
    )
  }
}

ParticipationHistoryComponent.propTypes = {
  futureEvents: PropTypes.array,
  pastEvents: PropTypes.array,
  seasons: PropTypes.array,
  seasonId: PropTypes.string,
  futureEventsCount: PropTypes.number,
  pastEventsCount: PropTypes.number,
  playerName: PropTypes.string.isRequired,
  filterParticipationHistory: PropTypes.func,
  dataIsLoading: PropTypes.bool,
  target: PropTypes.string,
  moneyEarnedTotal: PropTypes.string,
  isPGA: PropTypes.bool.isRequired,
  areLoadingEventsIds: PropTypes.array,
  fetchMoneyEarnedInformation: PropTypes.func,
  loadedEvents: PropTypes.object,
  isOpenedEventPopup: PropTypes.bool,
  currentlyOpenedEventPopup: PropTypes.string,
  selectOpenedMoneyEarnedInformationPopup: PropTypes.func,
  checkInList: PropTypes.array,
  checkInsCount: PropTypes.number.isRequired,
  deleteCheckIn: PropTypes.func,
  showCheckInTable: PropTypes.bool,
  usgaIndex: PropTypes.string,
  photoUrl: PropTypes.string,
  isOpenedLeaderboardPopup: PropTypes.bool,
  currentlyRoundLeaderboardPopup: PropTypes.string,
  onLeaderboardOpen: PropTypes.func,
  loadingLeaderboards: PropTypes.bool,
  fetchLeaderboardStart: PropTypes.func,
  fetchLeaderboardEnd: PropTypes.func,
  viewOption: PropTypes.string,
  viewChanged: PropTypes.func,
  futureRounds: PropTypes.array,
  pastRounds: PropTypes.array,
  futureRoundsCount: PropTypes.number,
  pastRoundsCount: PropTypes.number,
  editProfileUrl: PropTypes.string,
  pageFutureRounds: PropTypes.number,
  pagePastRounds: PropTypes.number,
  pageFutureEvents: PropTypes.number,
  pagePastEvents: PropTypes.number,
  setPage: PropTypes.func,
  fetchParticipationHistoryData: PropTypes.func,
  hiText: PropTypes.string,
}

export default ParticipationHistoryComponent
